import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree} from '@angular/router';
import {Observable} from 'rxjs';
import {AuthService} from '../services/auth.service';
import {map} from 'rxjs/operators';
import {Constants, PermissionName} from "../utils/constants";
import {hasAnyPermission, User} from '../model/user';

@Injectable({
  providedIn: 'root'
})
export class ReservedRoutesGuard {


  constructor(private router: Router, private authService: AuthService) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> {
    return this.evaluate(route.data.permissions , state.url);
  }

  canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> {
    return this.evaluate(route.data.permissions, state.url);
  }

  private evaluate(routePermissions: PermissionName[] | undefined, url: string): Observable<boolean | UrlTree> {
    return this.authService.onUserChange().pipe(
      map((user: User | undefined) => {

        if (!user) {
          this.authService.redirectUrl = url;
          return this.router.createUrlTree(['/login']);
        }

        if (routePermissions?.length) {
          if (!hasAnyPermission(user, routePermissions)) {
            this.authService.redirectUrl = url;
            return this.router.createUrlTree(['/reserved']);
          }
        }
        return true;
      })
    );
  }


}
